export default __webpack_public_path__ + "static/media/anywhere.2b5ccf35.png";